import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/List.tsx
const ListIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M6.2 6a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM7 6c0-.552.364-1 .813-1h11.375c.448 0 .812.448.812 1s-.364 1-.813 1H7.813C7.364 7 7 6.552 7 6ZM7.813 11c-.45 0-.813.448-.813 1s.364 1 .813 1h11.375c.448 0 .812-.448.812-1s-.364-1-.813-1H7.813ZM7 18c0-.552.364-1 .813-1h11.375c.448 0 .812.448.812 1s-.364 1-.813 1H7.813C7.364 19 7 18.552 7 18ZM6.2 12a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0ZM5 19.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z",
		fill: props.fill || "currentColor"
	})
}));
export { ListIcon };
